import React from 'react';
import MicroInteraction, { ApiMicroInteraction } from '@chewy/pet-profile-micro-interaction';
import {
  AnalyticsData,
  StoreFrontAnalytics,
} from '@chewy/pet-profile-micro-interaction/dist/esm/packages/micro-interaction/src/types';
import '@chewy/pet-profile-micro-interaction/dist/esm/main.css';
import { useQuery } from 'react-query';
import analytics from 'storefront-analytics/dist/analytics';
import { SimplePet } from '@chewy/pet-profile-micro-interaction/dist/esm/packages/micro-interaction/src/services/types/petApi';
import { getMicroInteraction, getMintRequestParam } from '../../api/mintApi';
import useLocationQuery from '../../hooks/useLocationQuery';
import packageLockJson from '../../../../package-lock.json';
import {
  GetMicroInteractionClientPageEnum,
  GetMicroInteractionClientPlatformTypeEnum,
} from '../../api/generated-client/MicroInteraction-Service.v1';

export type MicroInteractionWrapperProps = {
  petId?: number;
  customAnalyticsClient?: StoreFrontAnalytics;
  onUpdateSuccess?: (data: SimplePet) => void;
};

export const getMintVersion = (): string => {
  const microInteractionVersion =
    packageLockJson.dependencies['@chewy/pet-profile-micro-interaction'];
  return microInteractionVersion.version;
};

export const MicroInteractionWrapper = ({
  customAnalyticsClient,
  petId,
  onUpdateSuccess,
}: MicroInteractionWrapperProps) => {
  const query = useLocationQuery();
  const mintId = query.get('mi_id');
  const mintIdParsed = mintId ? Number.parseInt(mintId) : null;
  const mintQueryParams = getMintRequestParam(
    mintIdParsed,
    getMintVersion(),
    GetMicroInteractionClientPageEnum.PetProfileView,
    GetMicroInteractionClientPlatformTypeEnum.Web,
    petId || null,
  );

  const { isLoading: mintLoading, data: mintData } = useQuery(
    [getMicroInteraction.key, mintQueryParams],
    getMicroInteraction,
  );

  return !mintLoading ? (
    <div className="pet-profile__microinteraction">
      <MicroInteraction
        miData={mintData as ApiMicroInteraction}
        onUpdateSuccess={onUpdateSuccess}
        analyticsClient={
          customAnalyticsClient || {
            segmentTrack: (event: string, data: AnalyticsData) => {
              analytics.segmentTrack(event, data);
            },
          }
        }
      />
    </div>
  ) : null;
};
